import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
          <div className="text-center">
            <div style={{
              width: '80px', height: '80px', borderRadius: '50%',
              background: 'rgba(255, 101, 132, 0.15)', color: '#FF6584',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 1.5rem', fontSize: '2.5rem',
            }}>
              <i className="bi bi-exclamation-triangle"></i>
            </div>
            <h5 className="fw-bold mb-2">Something went wrong</h5>
            <p className="text-muted small mb-3">An unexpected error occurred</p>
            <button
              className="btn btn-primary-custom btn-sm"
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.href = '/';
              }}
            >
              <i className="bi bi-arrow-clockwise me-1"></i>Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
